import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from '@mri-platform/shared/core';
import { UserEnrollmentCallBackResponse, UserEnrollmentRequest, UserEnrollmentResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class UserEnrollmentService {
  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfig
  ) {}

  postUserEnroll(params: UserEnrollmentRequest) {
    const updateParams = {
      ...params,
      platformType: +params.platformType,
      callBackUrl: `${window.location.origin}/callback`
    };
    return this.http.post<UserEnrollmentResponse>(`${this.apiConfig.url}/welcome/enroll`, updateParams, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getCallBack(params: UserEnrollmentCallBackResponse) {
    const { code, state, scope } = params;
    return this.http.get<UserEnrollmentResponse>(
      `${this.apiConfig.url}/welcome/callback?code=${code}&state=${state}&scope=${scope}`
    );
  }
}
